/** @jsx jsx */
import { jsx, Divider } from 'theme-ui'
import styled from '@emotion/styled'

const StyledSeparator = styled(Divider)``

const CustomSeparator = ({ ...props }) => {
  return <StyledSeparator {...props}></StyledSeparator>
}

export default CustomSeparator
